export const GET_REALMS = "GET_REALMS";
export const SET_FILTERED_REALMS = "GET_FILTERED_REALMS";
export const SET_SELECTED_REALM = "GET_SELECTED_REALMS";
export const ADD_REALM = "ADD_REALM";
export const GET_SELECTED_REALM_DETAILS = "GET_SELECTED_REALM_DETAILS";
export const RESET_REALMS = "RESET_REALMS";
export const GET_REALM_ENTITLEMENTS = "GET_REALM_ENTITLEMENTS";
export const GET_ALL_IDPS = "GET_ALL_IDPS";
export const GET_BY_IDP_STATUS = "GET_BY_IDP_STATUS";